"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureDistance = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MeasureDistance = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "measure-distance", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "measure-distance", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M27 21a1 1 0 1 0-2 0v5h-3v-2a1 1 0 1 0-2 0v2h-3v-5a1 1 0 1 0-2 0v5h-3v-2a1 1 0 1 0-2 0v2H7v-5a1 1 0 1 0-1.998.002l.01 5.878c0 .619.503 1.12 1.121 1.12h19.744c.62 0 1.123-.503 1.123-1.123V21ZM27.886 9.07 22.84 4l-1.903 1.91 1.91 1.92H9.363l1.77-1.778L9.23 4.14 4.183 9.212l1.903 1.91.03-.03 3.185 3.2 1.902-1.91-1.84-1.849h13.274l-1.77 1.778 1.902 1.912 4.206-4.227-.004-.004.915-.921Z", fill: "#172344" }) })) })));
};
exports.MeasureDistance = MeasureDistance;
